@if (programOverviewErrorMessage?.text) {
<div>
  <p class="background-white m-t-xs m-b-xxl">
    <span class="m-l-lg">
      <error-message [errorMessage]="programOverviewErrorMessage"></error-message>
    </span>
  </p>
</div>
}

@if (showLoading) {
<div class="loading">
  <mat-spinner></mat-spinner>
</div>
}

@if (program) {
<div>
  <div overview-dashboard>
    <div>
      <div>
        <div library>
          <img src="assets/icons/programs-banner-stamp.svg" alt="">
        </div>
        <div>
          <span>
            {{ program?.startDate | dateFormat : 'ddd, ll withoutyear' }} -
            {{ program?.endDate | dateFormat : 'ddd, ll' }}
          </span>
          <span>
            {{ program?.startDate | getdays : program?.endDate }} Days
            @if (program?.programType) {
            &bull; {{ program?.programType }}
            }
          </span>
        </div>
      </div>
      <div>
        <span icl>{{ program?.name }}</span>
      </div>
    </div>
    <div right-section>
      <div top-cards>
        <div>
          <span><img src="assets/icons/courses-banner.svg" alt=""></span>
          <div>
            <span>{{ (program.counts)?.classes || 0 }}</span>
            <span>Classes</span>
          </div>
        </div>
        <div>
          <span><img src="assets/icons/events.svg" alt=""></span>
          <div>
            <span>{{ (program.counts)?.events || 0 }}</span>
            <span>Sessions</span>
          </div>
        </div>
      </div>
      <div bottom-cards>
        <div>
          <span><img src="assets/icons/participants-banner.svg" alt=""></span>
          <div>
            <span>{{ (program.counts)?.participants || 0 }}</span>
            <span>Participants</span>
          </div>
        </div>
        <div>
          <span><img src="assets/icons/facilitators-banner.svg" alt=""></span>
          <div>
            <span>{{ (program.counts)?.facilitators || 0 }}</span>
            <span>Facilitators</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div list-group>
    <div>
      <span>{{ program?.cEventId }}</span>
      <span>Cvent Event ID</span>
    </div>
    <div>
      <span>{{ program?.sabaProgramId }}</span>
      <span>Saba Program Code</span>
    </div>
    <div>
      <span>{{ program?.hyatAcronym }}</span>
      <span>Hyatt Acronym</span>
    </div>
    <div>
      <span>{{ program?.hyattBookingNo }}</span>
      <span>Hyatt Booking Ref No.</span>
    </div>
    <div>
      <span>{{ program?.concurId }}</span>
      <span>Concur Meeting Star ID</span>
    </div>
  </div>
  <div view-mode>
    <span>Schedule</span>
    <span class="{{ program?.startDate | classcolor : program?.endDate }}">
      {{ program?.startDate | days : program?.endDate }}
    </span>
  </div>

  @if (programList?.length) {
  <div>
    @for (list of programList | orderBy: {property: 'key', direction: 1, isDateSort: true}; track list; let i = $index)
    {
    <div>
      <div date-timeline>
        <div>
          <span>DAY {{ i + 1 }} OF {{ programList.length }}</span>
          <span>&#8226;</span>
          <span>{{ list.key | dateFormat : 'overviewdate' }}</span>
        </div>
      </div>
      <div level #morning>
        @if (morning.nextSibling?.innerHTML?.length > 48) {
        <span>Morning Session</span>
        }
      </div>
      <div card-section-morning>
        @for (item of list.value | programs:'morning'; track item) {
        <div>
          <div a>
            <span [ngClass]="{'active': curTime > item.startTime}">
              <i class="material-icons">{{ item?.type }}</i>
            </span>
          </div>
          <div b>
            <div>
              <span title="{{ item?.title }}">{{ item?.title }}</span>
            </div>
            <div>
              <span>{{ item?.startTime }} - {{ item?.endTime }}</span>
              <span>&#8226;</span>
              <span>{{ item?.location }}</span>
            </div>
          </div>
        </div>
        }
      </div>
      <div level #afternoon>
        @if (afternoon.nextSibling?.innerHTML?.length > 48) {
        <span>Afternoon Session</span>
        }
      </div>
      <div card-section-morning>
        @for (item of list.value | programs:'afternoon'; track item) {
        <div>
          <div a>
            <span>
              <i class="material-icons">{{ item?.type }}</i>
            </span>
          </div>
          <div b>
            <div>
              <span [ngClass]="{'active': curTime > item.startTime}" title="{{ item?.title }}">
                {{ item?.title }}
              </span>
            </div>
            <div>
              <span>{{ item?.startTime }} - {{ item?.endTime }}</span>
              <span>&#8226;</span>
              <span>{{ item?.location }}</span>
            </div>
          </div>
        </div>
        }
      </div>
      <div level #evening>
        @if (evening.nextSibling?.innerHTML?.length > 48) {
        <span>Evening Session</span>
        }
      </div>
      <div card-section-morning>
        @for (item of list.value | programs:'evening'; track item) {
        <div>
          <div a>
            <span>
              <i class="material-icons green">{{ item?.type }}</i>
            </span>
          </div>
          <div b>
            <div>
              <span [ngClass]="{'active': curTime > item.startTime}" title="{{ item?.title }}">
                {{ item?.title }}
              </span>
            </div>
            <div>
              <span>{{ item?.startTime }} - {{ item?.endTime }}</span>
              <span>&#8226;</span>
              <span>{{ item?.location || 'TBD' }}</span>
            </div>
          </div>
        </div>
        }
      </div>
    </div>
    }
  </div>
  } @else {
  @if (!showLoading) {
  <div class="background-white m-t-xs m-b-xxl">
    <p class="m-l-lg">No schedule data available.</p>
  </div>
  }
  }
</div>
}